import { Dropdown, InputField, Text, RadioButton, Button } from '../../../components/SecondaryMarket';
import { fontSizes } from '../../../constants/constants';
import dynamicfunction from '../../../utils/dynamicfunction';
import ViewReverse from '../../../components/ViewReverse';
import ViewItems from '../../../components/ViewItems';
import icons from '../../../constants/icons';
import { Formik } from 'formik';
import { account_operation_schema, account_operation_validation_schema, emptySignatory } from '../../../validations_schemas/acount_operation_validation_schema';
import { useDispatch, useSelector } from 'react-redux';
import { isEmptyValue, alphabet_numeric_regix, alphabet_regix, getRejectedFieldData, getSectionRejectedFields, numeric_integer_regix } from '../../../utils/functions';
import DocumentUploader from '../../../components/SecondaryMarket/Uploader';
import { cn, formatNumbers, getContentKeyAccToLang } from '../../../utils/utils';
import { downloadAccountOpeningDocument } from '../../../store/actions/accountOpeningAction';
import { ReactSVG } from 'react-svg';

const AccountOperation = ({ isKYC, formRef, percentage }) => {
  const { TextWeight, isArabic } = dynamicfunction();
  const dispatch = useDispatch()
  const { corporate_dropdown_data, corporate_kyc_data, rejection_summary, is_rejected, field_codes } = useSelector((state) => state.corporate);
  const accountOperationData = corporate_kyc_data?.accountOperation
  const corpKycContent = useSelector((state) => state.content?.corpKycContent);
  const corpAOContent = useSelector((state) => state.content?.corpAOContent);
  const contant = isKYC ? corpKycContent : corpAOContent

  const rejectedFields = getSectionRejectedFields(rejection_summary, 7);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(contant?.corporate_account_operation?.data?.attributes, key, isArabic);
  };

  return (
    <div>
      <ViewReverse className={cn('w-full items-center gap-2 justify-between', isKYC && 'cursor-pointer')}>

        <ViewReverse className="flex items-center gap-2">
          <Text text={getContentKey("company_account_operation")} weight={TextWeight.headingRegular} className={'text-dark-blue'} size={fontSizes.h30} />
          {rejectedFields?.length > 0 && <ReactSVG src={icons.heading_info_outline_icon} />}
        </ViewReverse>

        <ViewReverse className={'items-center gap-2'}>
          <Text text={`${formatNumbers(percentage) ?? 0}%`} className={'text-dark-blue'} size={fontSizes.h14} />
          {/* {isKYC && <ReactSVG src={icons.downArrow} className={cn(isOpen ? 'rotate-180' : 'rotate-0')} />} */}
        </ViewReverse>
      </ViewReverse>

      <Formik
        innerRef={formRef}
        validationSchema={account_operation_validation_schema}
        initialValues={account_operation_schema(accountOperationData)}
        enableReinitialize
        onSubmit={() => { }}
      >
        {({ values, setFieldValue, errors }) => {

          const addSignatory = () => {
            if (values.accountOperationAuthSigns.length >= 3) return;
            setFieldValue("accountOperationAuthSigns", [
              ...values.accountOperationAuthSigns,
              {
                ...emptySignatory,
                sequenceId: 1,
                corpClientApplicationAccountOperationAuthSignId: 0
              },
            ]);
          };

          const updateSignatory = (index, key, value) => {
            const updated = [...values.accountOperationAuthSigns];
            updated[index] = { ...updated[index], [key]: value };
            setFieldValue("accountOperationAuthSigns", updated);
          };
          const deleteSignatory = (index) => {
            const updated = [...values.accountOperationAuthSigns];
            updated.splice(index, 1);
            setFieldValue("accountOperationAuthSigns", updated);
          }

          return (
            <div className='space-y-6'>
              <ViewItems className={'mt-8'}>
                <Text text={getContentKey("account_management")} isEmpty={isEmptyValue(values?.accountManagement)} size={fontSizes.h14} className={'text-primary-light mb-3'} isRequired={true} isTruncate={false} />
                <ViewReverse className={'md:gap-6 w-full'} isResponsive>
                  {corporate_dropdown_data?.accountManagement?.map((item) => (
                    <RadioButton
                      label={item?.name}
                      key={item?.id}
                      selected={values?.accountManagement === item?.id}
                      onClick={() => {
                        setFieldValue('accountManagement', item?.id);
                      }}
                      className={'py-2.5'}
                      error={getContentKey(errors?.accountManagement)}
                      remarksMetadata={values?.accountManagement !== accountOperationData?.accountManagement ? null : {
                        sectionId: 7,
                        key: 'accountManagement',
                      }}
                    />
                  ))}
                  {values?.accountManagement === 1091 && <InputField
                    maxLength={50}
                    onChange={(text) => {
                      setFieldValue("accountManagementOther", text)
                    }}
                    value={values?.accountManagementOther}
                    error={getContentKey(errors?.accountManagementOther)}
                  />}
                </ViewReverse>
              </ViewItems>
              {values.accountOperationAuthSigns.map((sign, index) => {
                const signatoryKeys = [
                  index === 0 ? "fullNameFirstAuthorizedSignatory" : index === 1 ? "fullNameSecondAuthorizedSignatory" : "fullNameThirdAuthorizedSignatory",
                  index === 0 ? "nationalIDIqamaOrPassportNoFirst" : index === 1 ? "nationalIDIqamaOrPassportNoSecond" : "nationalIDIqamaOrPassportNoThird",
                  index === 0 ? "nationalityFirst" : index === 1 ? "nationalitySecond" : "nationalityThird",
                  index === 0 ? "jobTitleFirst" : index === 1 ? "jobTitleSecond" : "jobTitleThird",
                ];
                const isSignatoryRejected = signatoryKeys.some((key) => getRejectedFieldData(rejectedFields, field_codes, key)?.remarks?.length > 0);
                const isEditable = (is_rejected && isSignatoryRejected) || !is_rejected;

                return (
                  <ViewItems key={index} className={'w-full bg-light-background p-6 space-y-6 rounded-lg'}>
                    <ViewReverse className={"justify-between w-full"}>
                      <Text
                        text={`${getContentKey("signatory")} #${index + 1}`}
                        weight={TextWeight.medium}
                        className="text-light-blue"
                        size={fontSizes.h22}
                      />
                      <ReactSVG
                        src={icons.cross}
                        className={cn("cursor-pointer", !isEditable && "cursor-not-allowed opacity-50")}
                        onClick={() => isEditable && deleteSignatory(index)}
                      />
                    </ViewReverse>
                    <InputField
                      label={getContentKey("full_name")}
                      value={sign?.fullName}
                      isRequired
                      placeholder={getContentKey("full_name")}
                      onChange={(text) => {
                        if (alphabet_regix.test(text)) {
                          updateSignatory(index, "fullName", text);
                        }
                      }}
                      maxLength={50}
                      className={'bg-white'}
                      error={getContentKey(errors?.accountOperationAuthSigns?.[index]?.fullName)}
                      remarksMetadata={sign?.fullName !== accountOperationData?.accountOperationAuthSigns?.[index]?.fullName ? null : {
                        sectionId: 7,
                        key: `${index === 0 ? "fullNameFirstAuthorizedSignatory" :
                          index === 1 ? "fullNameSecondAuthorizedSignatory" : "fullNameThirdAuthorizedSignatory"}`,
                      }}
                    />
                    <ViewReverse className={'gap-6 w-full'} isResponsive>
                      <InputField
                        label={getContentKey("national_iqama_passport")}
                        value={sign?.identificationNo}
                        isRequired
                        placeholder={getContentKey("national_iqama_passport_placeholder")}
                        maxLength={50}
                        onChange={(text) => {
                          if (numeric_integer_regix.test(text)) {
                            updateSignatory(index, "identificationNo", text);
                          }
                        }}
                        error={getContentKey(errors?.accountOperationAuthSigns?.[index]?.identificationNo)}
                        className={'bg-white'}
                        isLabelHeight
                        labelDivClass={'md:h-8 lg:h-6'}
                        remarksMetadata={sign?.identificationNo !== accountOperationData?.accountOperationAuthSigns?.[index]?.identificationNo ? null : {
                          sectionId: 7,
                          key: `${index === 0 ? "nationalIDIqamaOrPassportNoFirst" :
                            index === 1 ? "nationalIDIqamaOrPassportNoSecond" : "nationalIDIqamaOrPassportNoThird"}`
                        }}
                      />
                      <Dropdown
                        label={getContentKey("nationality")}
                        placeholder={getContentKey("select_nationality")}
                        valueKey={'name'}
                        value={
                          sign?.nationalityId
                            ? corporate_dropdown_data?.country?.find(
                              (c) => c.id === sign?.nationalityId
                            )
                            : null
                        }
                        options={corporate_dropdown_data?.country ?? []}
                        onSelect={(val) =>
                          updateSignatory(index, "nationalityId", val?.id)
                        }
                        isLabelHeight
                        labelDivClass={'md:h-8 lg:h-6'}
                        error={getContentKey(errors?.accountOperationAuthSigns?.[index]?.nationalityId)}
                        remarksMetadata={sign?.nationalityId !== accountOperationData?.accountOperationAuthSigns?.[index]?.nationalityId ? null : {
                          sectionId: 7,
                          key: `${index === 0 ? "nationalityFirst" :
                            index === 1 ? "nationalitySecond" : "nationalityThird"}`
                        }}
                      />
                      <InputField
                        label={getContentKey("job_title")}
                        isLabelHeight
                        isRequired
                        value={sign?.jobTitle}
                        maxLength={50}
                        placeholder={getContentKey("job_title_placeholder")}
                        className={'bg-white'}
                        onChange={(text) => {
                          if (alphabet_regix.test(text)) {
                            updateSignatory(index, "jobTitle", text);
                          }
                        }}
                        labelDivClass={'md:h-8 lg:h-6'}
                        error={getContentKey(errors?.accountOperationAuthSigns?.[index]?.jobTitle)}
                        remarksMetadata={sign?.jobTitle !== accountOperationData?.accountOperationAuthSigns?.[index]?.jobTitle ? null : {
                          sectionId: 7,
                          key: `${index === 0 ? "jobTitleFirst" :
                            index === 1 ? "jobTitleSecond" : "jobTitleThird"}`
                        }}
                      />
                    </ViewReverse>
                    <ViewItems className={"w-full"}>
                      {
                        !sign?.signatureDocument?.fileName && !sign?.signatureDocument?.name ? (
                          <DocumentUploader
                            className='w-full'
                            label={getContentKey("signature")}
                            getContentKey={getContentKey}
                            required
                            documentTypeId={1150}
                            fileName={sign?.signatureDocument?.fileName || sign?.signatureDocument?.name}
                            error={getContentKey(errors?.accountOperationAuthSigns?.[index]?.signatureDocument)}
                            disabled={!isEditable}
                            onUpload={({ file }) => {
                              updateSignatory(index, "signatureDocument", file)
                            }
                            }
                          />
                        ) : (
                          <ViewReverse className={"w-full justify-between"}>
                            <Text text={sign?.signatureDocument?.fileName || sign?.signatureDocument?.name} />
                            <div className='flex items-center gap-2'>
                              {
                                sign?.signatureDocument?.fileName && (
                                  <ReactSVG
                                    src={icons.download_grey_icon}
                                    className="cursor-pointer"
                                    onClick={() => (
                                      dispatch(downloadAccountOpeningDocument({
                                        payloadId: sign?.signatureDocument?.documentPayloadId,
                                        languageId: isArabic ? 2 : 1

                                      }))
                                    )}
                                  />
                                )
                              }
                              <ReactSVG
                                src={icons.delete_icon}
                                className={cn("cursor-pointer", !isEditable && "cursor-not-allowed opacity-50")}
                                onClick={() => isEditable && updateSignatory(index, "signatureDocument", null)}
                              />
                            </div>
                          </ViewReverse>
                        )
                      }
                    </ViewItems>
                  </ViewItems>
                )
              })}
              {
                values.accountOperationAuthSigns.length < 3 && (
                  <Button
                    text={getContentKey("add_signatory")}
                    weight={TextWeight.bold}
                    textSize={fontSizes.h14}
                    className={cn('bg-white !mt-9 border border-grey text-dark-blue w-full', is_rejected && 'cursor-not-allowed opacity-50')}
                    icon={icons.plus_icon}
                    onClick={addSignatory}
                    disabled={is_rejected || values.accountOperationAuthSigns.length >= 3}
                  />
                )
              }
            </div>
          )
        }}
      </Formik>
    </div>
  );
};

export default AccountOperation;
